<template>
  <a-card :bordered="false">
    <app-warp title='登录'>
      <template #app-content>
        <div class="pic_content" :style="'background-color:'+form.cover_color">
          <img class="width100" v-show='form.cover_image_url' style="display: block;height: auto;"
            :src="info.picdomain+form.cover_image_url" alt="">
          <img :src="info.picdomain+form.logo" alt="" class="logo">
          <div class="loginForm " :style="'color:'+form.button_color">
            <div class="form-item m-b-30">
              <span class="iconfont  icon-a-zhanghao1x m-r-10"></span>
              <span style="color:#D2D2D2">请输入账号</span>
            </div>
            <div class="form-item m-b-30">
              <span class="iconfont  icon-a-mima1x m-r-10"></span>
              <span style="color:#D2D2D2">请输入密码</span>
            </div>
            <div class="form-item s_flex_bian_c fz-12 m-b-60">
              <span class="s_flex_ali" style="color:#121212"> <span class="dot"></span>记住密码</span>
              <span class="text-uline">忘记密码?</span>
            </div>
            <div class="form-sub width98 marigin_lr_auto text-ac height-46 s_lin_h46 bor-rad-46"
              :style="'color:'+form.button_text_color+';background-color:'+form.button_color">
              {{form.button_name}}
            </div>
          </div>
        </div>
      </template>
      <template #app-sider>
        <div style="width:95%;margin-left:20px">
          <SmallSquare content="设置经销商端的登录页面，经销商、经销商业务员登录界面样式共用" />
          <div class="moduleContent m-t-20">
            <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="{span:4}" :wrapper-col="{span:20}">
              <a-form-item label="背景图片" help="推荐尺寸750*450" class="m-b-15">
                <div class="s_flex_ali">
                  <div class="width-104 height-104 s_over">
                    <material :groupType='1' :image="form.cover_image_url" :max="1" v-on:handlechoose="(data)=>{
                      form.cover_image_url=data}" v-on:handledel="form.cover_image_url = ''" />
                  </div>
                  <a-button type="link" @click='form.cover_image_url = "/web_base_assets/salesman/storeLogin.png"'>恢复默认值</a-button>
                </div>
              </a-form-item>
              <a-form-item label="logo图片" help="推荐尺寸130*130，大小500Kb以内" class="m-b-15">
                <div class="s_flex_ali">
                  <div class="width-104 height-104 s_over">
                    <material :groupType='1' :image="form.logo" :max="1" v-on:handlechoose="(data)=>{
                        form.logo=data}" v-on:handledel="form.logo=''" />
                  </div>
                  <a-button type="link" @click='form.logo = "/web_base_assets/salesman/dealer_base_logo.png"'>恢复默认值</a-button>
                </div>
              </a-form-item>
              <a-form-item label="页面背景色" help="页面整体背景色">
                <div>
                  <a-input v-model:value="form.cover_color" type="color" style="width:250px" />
                  <a-button class="m-l-15" type="link" @click='form.cover_color = "#F8F8F8"'>恢复默认值</a-button>
                </div>
              </a-form-item>
              <a-form-item label="按钮颜色">
                <a-input v-model:value="form.button_color" type="color" style="width:250px" />
                <a-button class="m-l-15" type="link" @click='form.button_color = "#4E7DF1"'>恢复默认值</a-button>
              </a-form-item>
              <a-form-item label="按钮文字" help="最多6个字">
                <a-input v-model:value="form.button_name" placeholder="请输入按钮文字" style="width:250px" :maxlength='6'>
                </a-input>
              </a-form-item>
              <a-form-item label="按钮文字颜色">
                <a-input v-model:value="form.button_text_color" type="color" style="width:250px" />
              </a-form-item>

            </a-form>
          </div>
        </div>
        <a-button type="primary" v-has:setDealerLoginTemplate="updateFn" class='m-l-20 m-t-30' :loading="loading">保存</a-button>
      </template>
    </app-warp>
  </a-card>
</template>
<script>
  import { DownOutlined, PlusOutlined ,UpOutlined,InboxOutlined} from "@ant-design/icons-vue";
  import { setDealerLoginTemplate, getDealerLoginTemplate } from '@/api/dealer.js'
  import { iscode } from "@/utils/app";
  import { onMounted, ref } from "@vue/runtime-core";
  import store from "@/store";
  import { message } from "ant-design-vue";
  // 初始化默认筛选项数值
  let defForm = {
    cover_image_url: '/web_base_assets/salesman/storeLogin.png',
    logo: '/web_base_assets/salesman/dealer_base_logo.png',
    cover_color: '#F8F8F8',
    button_color: '#4E7DF1',
    button_name: '登录',
    button_text_color: '#ffffff',
  }
  export default {
    setup() {
      const form = ref({ ...defForm });
      const ruleForm = ref();
      const loading = ref(false);
      const initData = async () => {
        const hide = message.loading('正在加载中...', 0);
        let result = await getDealerLoginTemplate().then((res) => res.data).catch((error) => error);
        console.log(result);
         setTimeout(hide);
        if (iscode(result)) {
          if(!result.data['content']) return;
          form.value = result.data.content
        } else {
          message.error(result.msg);
        }
      };
      const updateFn = async () => {
        console.log(form.value);
        loading.value = true;
        let result = await setDealerLoginTemplate({ content: JSON.stringify(form.value) }).then((res) => res.data).catch((error) => error);
             console.log(result);
              if (iscode(result)) {
          initData();
        } else {
          message.error(result.msg);
        }
        loading.value = false;
      };
      onMounted(() => {
        initData();
        console.log(form.value);
      });
      return {
        ruleForm,
        form,
        updateFn,
        info: store.state.user.info,
        loading
      };
    },
  };
</script>

<style lang="less" scoped>
  @import url("//at.alicdn.com/t/font_2663552_ykd41piorhd.css");

  .moduleContent {
    height: auto;
    background: #fdfdfd;
    border: 1px solid #ddd;
    padding: 20px 10px 40px 10px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    user-select: none;
  }

  .pic_content {
    position: relative;
    height: 100%;

    .logo {
      width: 70px;
      height: 70px;
      position: absolute;
      top: 45px;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 50%;
    }

    .loginForm {
      width: 90%;
      height: 275px;
      background-color: #fff;
      border-radius: 10px;
      position: absolute;
      left: 50%;
      top: 150px;
      transform: translateX(-50%);
      padding: 20px;
      font-size: 16px;

      .dot {
        display: inline-block;
        width: 15px;
        height: 15px;
        background-color: #E7E7E7;
        margin-right: 5px;
        border-radius: 50%;
      }
    }
  }

  .scanBnt {
    position: absolute;
    left: 0;
    bottom: 180px;
  }
</style>